module.exports = __webpack_public_path__ + "static/media/Scan 10.08d3c3ac.jpeg";